import React from 'react';
import { Nav } from 'react-bootstrap';

import { useTranslation } from 'react-i18next';
import UserActions from './UserActions';
import { useAuth } from '../../../context';

function NavbarNav() {
  const { env } = useAuth();
  const { t } = useTranslation();
  return (
    <Nav navbar className="flex-row align-items-center">
      <div className="me-3">
        {t('common:labels.environment')}
        {': '}
        <span className="text-uppercase">
          {env === 'sandbox' ? t('env.sandbox.label') : t('env.prod.label')}
        </span>
      </div>
      <UserActions />
    </Nav>
  );
}

export default NavbarNav;
